module.exports = __webpack_public_path__ + "static/media/logoMovil_cancer_mama.aeb96044.svg";